import {
    postFindHolderVisitRecord,
    postCreateHolderVisitRecord,
    putHolderVisitRecord,
    deleteHolderVisitRecord
} from './api/holdervisitrecord'

class HolderVisitRecordDataService {
    async findByCondition(holder_id, page, itemsPerPage){
        try{
            const result = await postFindHolderVisitRecord(holder_id, page, itemsPerPage)
            return result
        } catch (err) {
            return err
        } 
    }
    /*
    async getHolderVisitRecord(id) {
        try{
            const result = await getHolderVisitRecord(id)
            return result
        } catch (err) {
            return err
        } 
    }*/

    async createHolderVisitRecord(_holder_id, _visiting_date, _note){
        var params = {
            holder_visit_record: {
                holder_id: _holder_id,
                visiting_date: _visiting_date,
                note: _note
            }
        }
        try {
            const result = await postCreateHolderVisitRecord(params)
            return result
        } catch (err) {
            return err
        } 
    }

    async updateHolderVisitRecord(_id, _visiting_date, _note){
        var params = {
            holder_visit_record: {
                visiting_date: _visiting_date,
                note: _note
            }
        }
        try {
            const result = await putHolderVisitRecord(_id, params)
            return result
        } catch (err) {
            return err
        } 
    }

    async deleteHolderVisitRecord(_id){
        try {
            console.log(_id, 'deleteHolderVisitRecord, id')
            const result = await deleteHolderVisitRecord(_id)
            return result
        } catch (err) {
            return err
        } 
    }
}

export default new HolderVisitRecordDataService()